var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoThinSmall = function SvgInfoThinSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "currentColor",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.875 0a4.875 4.875 0 100 9.75 4.875 4.875 0 000-9.75zm0 9a4.125 4.125 0 110-8.25 4.125 4.125 0 010 8.25zm.75-1.875a.375.375 0 01-.375.375.75.75 0 01-.75-.75V4.875a.375.375 0 010-.75.75.75 0 01.75.75V6.75a.375.375 0 01.375.375zm-1.5-4.313a.562.562 0 111.125 0 .562.562 0 01-1.125 0z"
  })));
};
export default SvgInfoThinSmall;